<script lang="ts">
  import { form, field } from 'svelte-forms';
  import { required, pattern } from 'svelte-forms/validators';
  import RepositoryFactory, { INVITATION_UMOBILED } from '../../../../repositories/RepositoryFactory';
  import { VerifyInvitationCodeResult } from '../../../../repositories/invitationumobiled';

  export let handleCloseEvent!: any;

  const repository = RepositoryFactory[INVITATION_UMOBILED];

  // input項目
  const invitationCode1 = field('invitationCode1', '', [required(), pattern(/\b[a-zA-Z0-9]{4}\b/)]);
  const invitationCode2 = field('invitationCode2', '', [required(), pattern(/\b[a-zA-Z0-9]{4}\b/)]);
  const invitationCode3 = field('invitationCode3', '', [required(), pattern(/\b[a-zA-Z0-9]{4}\b/)]);
  const invitationCode4 = field('invitationCode4', '', [required(), pattern(/\b[a-zA-Z0-9]{4}\b/)]);
  const invitationCode5 = field('invitationCode5', '', [required(), pattern(/\b[a-zA-Z0-9]{4}\b/)]);

  const myForm = form(invitationCode1, invitationCode2, invitationCode3, invitationCode4, invitationCode5);

  let errorMessage: string = '';

  const handleConfirm = async () => {
    errorMessage = '';
    let hasErrorRequired = false;
    let hasErrorPattern = false;

    await myForm.validate().then(() => {
      hasErrorRequired =
        $myForm.hasError('invitationCode1.required') ||
        $myForm.hasError('invitationCode2.required') ||
        $myForm.hasError('invitationCode3.required') ||
        $myForm.hasError('invitationCode4.required') ||
        $myForm.hasError('invitationCode5.required');

      hasErrorPattern =
        $myForm.hasError('invitationCode1.pattern') ||
        $myForm.hasError('invitationCode2.pattern') ||
        $myForm.hasError('invitationCode3.pattern') ||
        $myForm.hasError('invitationCode4.pattern') ||
        $myForm.hasError('invitationCode5.pattern');
    });

    if (hasErrorRequired) {
      errorMessage = '招待コードを入力してください';
      return;
    }

    if (hasErrorPattern) {
      errorMessage = '招待コードは20文字で指定してください';
      return;
    }

    const invitationCode = `${$invitationCode1.value}${$invitationCode2.value}${$invitationCode3.value}${$invitationCode4.value}${$invitationCode5.value}`;

    let verifyInvitationCodeResult: VerifyInvitationCodeResult = null;

    await repository
      .verifyInvitationCode({ invitationCode: invitationCode })
      .then((result: VerifyInvitationCodeResult) => {
        verifyInvitationCodeResult = result;
      })
      .catch((error: any) => {});

    if (!verifyInvitationCodeResult) {
      errorMessage = '招待コードが使用済または誤っています。正しい招待コードを確認の上再度入力ください';
      return;
    }

    handleCloseEvent(verifyInvitationCodeResult);
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="container flex justify-between">
    <h1 class="text-base md:text-xl font-bold text-gray-700">招待コード入力</h1>
  </div>

  <div class="flex justify-center mt-5">
    <div class="flex justify-center items-center content-center shadow-sm h-30 w-auto p-5 form-background">
      <form>
        <div class="flex flex-row flex-wrap items-center gap-y-2 gap-x-1">
          <div class="flex-shrink">
            <input
              type="text"
              id="invitationCode1"
              autocomplete="off"
              maxlength="4"
              bind:value={$invitationCode1.value}
              required
            />
          </div>
          <div class="flex-none"><span class="text-center">-</span></div>
          <div class="flex-shrink">
            <input
              type="text"
              id="invitationCode2"
              autocomplete="off"
              maxlength="4"
              bind:value={$invitationCode2.value}
              required
            />
          </div>
          <div class="flex-none"><span class="text-center">-</span></div>
          <div class="flex-shrink">
            <input
              type="text"
              id="invitationCode3"
              autocomplete="off"
              maxlength="4"
              bind:value={$invitationCode3.value}
              required
            />
          </div>
          <div class="flex-none"><span class="text-center">-</span></div>
          <div class="flex-shrink">
            <input
              type="text"
              id="invitationCode4"
              autocomplete="off"
              maxlength="4"
              bind:value={$invitationCode4.value}
              required
            />
          </div>
          <div class="flex-none"><span class="text-center">-</span></div>
          <div class="flex-shrink">
            <input
              type="text"
              id="invitationCode5"
              autocomplete="off"
              maxlength="4"
              bind:value={$invitationCode5.value}
              required
            />
          </div>
        </div>
        <div class="flex items-center">
          <ul class="list-none list-inside">
            {#if errorMessage}
              <li><span class="helper-text">{errorMessage}</span></li>
            {/if}
          </ul>
        </div>
      </form>
    </div>
  </div>
  <div class="flex justify-center items-center mt-5 mb-5">
    <button type="button" class="tracking-widest form-button" on:click={handleConfirm}>確認</button>
  </div>
</div>

<style lang="postcss">
  .form-background {
    background-color: rgba(0, 0, 0, 0.02);
    @apply w-full;
  }

  input[type='text'] {
    font-size: 14px;
    color: rgba(0, 10, 23, 1);
    background-color: rgba(1, 6, 13, 0.06);
    @apply block p-3 min-h-12 w-20 focus:ring-0 focus:ring-blue-200 focus:border-transparent;
  }

  .form-button {
    @apply text-center text-sm font-medium rounded-none text-white bg-[#0fb9f5] h-12 w-1/3;
  }

  .form-button:hover {
    text-decoration: none;
    -webkit-filter: brightness(1.1);
    filter: brightness(1.1);
  }
  .helper-text {
    @apply text-xs text-red-500  mt-2;
  }
</style>
